import { AxiosInstance } from 'axios';
import { ShiftCategoriesRepository } from '@/model/repository/shift/ShiftCategoriesRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): ShiftCategoriesRepository => ({
    index() {
      return Repository.get(`${resource}`, { data: { errorHandle: false } });
    },
    show(id: string) {
      return Repository.get(`${resource}/${id}`);
    },
    create(payload) {
      return Repository.post(`${resource}`, payload);
    },
    update(id, payload) {
      return Repository.put(`${resource}/${id}`, payload);
    },
  });
